import { Grid, Typography } from '@mui/material';

import useHotelService from './hotel-ser-hooks';
import { HeaderLayout, Layout } from '../InRoomDining';
import { FullScreenLoader, ServiceCard } from '../../components';
import { useParams, useSearchParams } from 'react-router-dom';
import useSubProperty from '../SubProperty/sub-property-hooks';
import { TalkToUS } from '../../components/TalkToUs';
import { customTheme } from '../../constants';
import { ThemeProvider } from '@material-ui/styles';
import RichTextContent from '../../components/RTEContent';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../utils';
const Services = () => {
  const [searchParams] = useSearchParams();
  const SPID = searchParams.get('SPID');
  const { hotelService, loading, chatText } = useHotelService();
  const {
    subProperties,
    loading: spLoading,
    showChatIcon,
    headerTitle
  } = useSubProperty();
  const { id } = useParams();
  const service = hotelService?.find(hs => hs.id === id);
  const textsToTranslate: string[] = [];

  if (service?.desc && !service?.desc?.toString().startsWith('<')) {
    textsToTranslate.push(service.desc);
  }

  if (SPID) {
    const filteredSubServices = subProperties
      ?.find(sp => sp?.id === SPID)
      ?.sub_services?.filter(ss =>
        hotelService
          ?.find(hs => hs.id === id)
          ?.sub_services?.some(ess => ss?.name === ess?.name)
      );

    if (Array.isArray(filteredSubServices)) {
      filteredSubServices.forEach(hotelService => {
        if (hotelService?.name) textsToTranslate.push(hotelService.name);
        if (
          hotelService?.desc &&
          !hotelService?.desc?.toString().startsWith('<')
        )
          textsToTranslate.push(hotelService.desc);
      });
    }
  } else {
    const services = hotelService?.find(
      service => service.id === id
    )?.sub_services;
    if (Array.isArray(services)) {
      services.forEach(hotelService => {
        if (hotelService?.name) textsToTranslate.push(hotelService.name);
        if (
          hotelService?.desc &&
          !hotelService?.desc?.toString().startsWith('<')
        )
          textsToTranslate.push(hotelService.desc);
      });
    }
  }

  console.log(textsToTranslate); // This list can be sent to the translation function

  const { language } = useLanguage();
  const translated = useTranslation(textsToTranslate, language.code);
  if (loading || spLoading) {
    return <FullScreenLoader />;
  }
  return (
    <Layout>
      <HeaderLayout title={(headerTitle as string) || 'Facilities'}>
        {showChatIcon && (
          <TalkToUS
            sx={{ alignItems: 'center' }}
            chat_text={chatText}
          ></TalkToUS>
        )}
      </HeaderLayout>
      <ThemeProvider theme={customTheme}>
        <Grid
          container
          spacing={2}
          sx={{
            px: 2,
            py: 0,
            flex: 1,
            mt: '0px',
            overflow: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': { display: 'none' }
          }}
        >
          {service?.desc ? (
            <Grid item width={'100%'}>
              {service?.desc?.toString().startsWith('<') ? (
                <RichTextContent content={service?.desc?.toString()} />
              ) : (
                <Typography sx={{ color: 'text.secondary' }}>
                  {translated[service?.desc] || service?.desc}
                </Typography>
              )}
            </Grid>
          ) : SPID ? (
            Array.isArray(subProperties) &&
            subProperties
              ?.find(sp => sp?.id === SPID)
              ?.sub_services?.filter(ss =>
                hotelService
                  ?.find(hs => hs.id === id)
                  ?.sub_services?.some(ess => ss?.name === ess?.name)
              )
              ?.map((hotelService: any) => {
                return (
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <ServiceCard
                      showInfo={true}
                      key={hotelService?.name}
                      label={translated[hotelService?.name]}
                      description={
                        translated[hotelService?.desc] || hotelService?.desc
                      }
                      image={hotelService?.img as string}
                      serviceID={hotelService?.service_id}
                      booking={hotelService?.booking_url}
                      bookingForm={hotelService?.booking_form}
                      spaIntegration={hotelService?.spa_integration}
                    />
                  </Grid>
                );
              })
          ) : (
            Array.isArray(hotelService) &&
            hotelService
              ?.find(service => service.id === id)
              ?.sub_services?.map((hotelService: any) => {
                return (
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <ServiceCard
                      showInfo={true}
                      key={hotelService?.name}
                      label={translated[hotelService?.name]}
                      description={
                        translated[hotelService?.desc] || hotelService?.desc
                      }
                      image={hotelService?.img as string}
                      serviceID={hotelService?.service_id}
                      booking={hotelService?.booking_url}
                      bookingForm={hotelService?.booking_form}
                      spaIntegration={hotelService?.spa_integration}
                      noti_msg={hotelService?.noti_msg}
                    />
                  </Grid>
                );
              })
          )}
        </Grid>
      </ThemeProvider>
    </Layout>
  );
};

export default Services;
